import { BaseUITools } from "@/uiControls/base/baseUITools";
import { VisionaryScene } from '@/visionaryControllers/visionaryScene';

import * as THREE from 'three';


export class ViewHelperController{
    private visionaryScene: VisionaryScene;
    private vecx: THREE.Vector3;
    private vecy: THREE.Vector3;
    private vecz: THREE.Vector3;
    private mat4: THREE.Matrix4;

    constructor(visionaryScene: VisionaryScene) {
        this.visionaryScene = visionaryScene;
        this.vecx = new THREE.Vector3();
        this.vecy = new THREE.Vector3();
        this.vecz = new THREE.Vector3();
        this.mat4 = new THREE.Matrix4();
    }

    public alignCamera(axis: string) {
        const camera = this.visionaryScene.getCamera();

        if (!camera) return;
        console.log("alignCamera-----------",axis);
        // 获取当前相机到原点的距离，如果相机在原点则使用默认距离
        const currentDistance = camera.position.length();
        const distance = currentDistance > 0.1 ? currentDistance : 10;

        // 使用原点作为目标点（也可以根据需要修改为场景中心）
        const target = new THREE.Vector3(0, 0, 0);
        let newPosition = new THREE.Vector3();

        switch (axis) {
            case 'px': // +X
                newPosition.set(distance, 0, 0);
                break;
            case 'nx': // -X
                newPosition.set(-distance, 0, 0);
                break;
            case 'py': // +Y
                newPosition.set(0, distance, 0);
                break;
            case 'ny': // -Y
                newPosition.set(0, -distance, 0);
                break;
            case 'pz': // +Z
                newPosition.set(0, 0, distance);
                break;
            case 'nz': // -Z
                newPosition.set(0, 0, -distance);
                break;
        }

        newPosition.add(target);
        camera.position.copy(newPosition);
        camera.lookAt(target);
    }
}
